import { createContext } from "react";

export const DasboardContext = createContext({});